import { Component, OnInit, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { OccurenceComments } from './occurence-comments.interface';
import { UtilService } from '@app/shared/utils';
import { OccurencesService } from '@app/occurences/occurences.service';
import { CONSTANTS } from '@app/shared/constants';
import { SnackbarService } from '@app/shared/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@app/core/language/language.service';

@Component({
  selector: 'app-occurence-list-comments',
  templateUrl: './occurence-list-comments.component.html',
  styleUrls: ['./occurence-list-comments.component.css']
})
export class OccurenceListCommentsComponent implements OnInit {
  @Input() occurrenceId: any;
  @Input() showLoading: Boolean = false;
  @Input() countComments: number;
  comments: Array<OccurenceComments>  = [];
  errorDownloadFile: Boolean = false;
  firstLoading: number = 1;

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private utils: UtilService,
    private occurenceService: OccurencesService,
    private _snackbarService: SnackbarService,
    public translate: TranslateService = null,
    private languageService: LanguageService
    ) {
    /** FIXME: Não deveria ser necessário usar o @ngx-translate da forma abaixo.
  Voltamos o codigo anterior, agora refatorado, ja que alguns componentes nao sao traduzidos sem ele
  */
    translate.addLangs(this.languageService.getSiteLanguageCodes());
    translate.use(this.languageService.siteLanguage);

    iconRegistry.addSvgIcon(
      'atachment',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/atachment.svg'));
  }

  ngOnInit() {
    this.firstLoading = 1;
  }

  loadComments(){
    if(this.firstLoading == 1 && this.comments.length == 0){
      this.showLoading = true;
      this.firstLoading ++;
    }
    this.occurenceService.getCommentsByOccurrenceById(this.occurrenceId).subscribe(
      occurrenceResponse => {
        this.comments = occurrenceResponse;
        this.showLoading = false;
        this.adjusteDataComments(this.comments);
      });
  }

  adjusteDataComments(comments: Array<OccurenceComments>) {
    if (comments && comments.length > 0) {
      comments.forEach(comment => {
        let width = 100;
        let lineBreak: string[];
        const maxCaracters = 400;
        const maxLenghtNameDocument = 15;
        const maxLines = 2;

        if (comment.description.length > maxCaracters) {
          width = width - 10;
          comment.simplifiedComment = comment.description.substring(0, maxCaracters);

        } else {
          lineBreak = comment.description.split('\n');

          if (lineBreak.length > 2){
            comment.showViewMore = true;
          }
        }
        if (comment.storedDocument && comment.storedDocument.length > 0) {
           width = width - 10;
           comment.storedDocument.forEach(document => {
            const infoNameDocument = document.documentName ? document.documentName.split('.') : [''];
            document.textSize = this.utils.getSizeFileText(document.fileSize ? document.fileSize.toString() : '');

             if (infoNameDocument[0].length > maxLenghtNameDocument) {
              document.simplifiedName = `${infoNameDocument[0].substring(0, maxLenghtNameDocument)}...${infoNameDocument[1]}`;
             }
           });
         }

        comment.width = `${width.toString()}%`;
        comment.showCompletComment = false;
      });
    }
  }

  downloadDocumentOfCommentById(id: number) {
    this.occurenceService.downloadDocumentOfCommentById(id)
    .subscribe((resp) => {
      this.errorDownloadFile = false;
      const { body } = resp;
      const { fileName, contentFile } = body;
      const blob = this.utils.convertByteJsonToBlob(contentFile);
      this.utils.downloadFileBlob(blob, fileName);
    }, err => {
      this.utils.showSnackbar(CONSTANTS.ERROR_DOWNLOAD_FILE_COMMENT);
    });
  }

  handleCountComments(): number {
    return this.comments.length === 0 ? this.countComments : this.comments.length;
  }
}
